import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// request interceptor
axios.interceptors.request.use(
  config => {
    const sessionUser = localStorage.getItem('userData') || sessionStorage.getItem('userData')
    if (sessionUser) {
      try {
        const sessionUserData = JSON.parse(sessionUser)
        if (sessionUserData && sessionUserData.token) {
          config.headers['AuthToken'] = sessionUserData.token
        }
      } catch (e) {
        console.error('解析用户信息失败', e)
      }
    }
    return config
  },
  error => {
    console.log('request error:', error)
    return Promise.reject(error)
  }
)

// response interceptor
axios.interceptors.response.use(
  response => {
    // ===== 关键：blob 请求直接返回完整 response，保留 headers =====
    if (response.config.responseType === 'blob') {
      return response
    }

    const res = response.data

    // 没有 code 字段，直接返回数据（正常业务数据）
    if (!res.code) {
      return res
    }

    // 各种状态码处理
    const tokenErrors = [10404, 10405, 100101, 10010, 100102]
    const errorMsgs = {
      100100: '用户令牌缺失，请重新登录',
      100101: '用户令牌无效，请重新登录',
      10010: '您的账号已在别处登录，如要继续使用请重新登录',
      100102: '用户令牌已过期，如要继续使用请重新登录'
    }

    if (res.code === 10403) {
      router.push('/401')
      return Promise.reject(new Error(res.msg || '无权限访问'))
    }

    if (tokenErrors.includes(res.code)) {
      const msg = errorMsgs[res.code] || res.msg
      Message.error(msg)
      router.push('/login')
      return Promise.reject(new Error(msg))
    }

    if (res.code === 204) {
      window.loadingFun && window.loadingFun(false)
      Message.error('访问过于频繁，如需继续访问，可联系我们。')
      return Promise.reject(new Error('访问过于频繁'))
    }

    // 其他错误
    Message({
      message: res.msg || 'Error',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(new Error(res.msg || 'Error'))
  },
  error => {
    Message({
      message: error.message || '请求失败',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default axios